import React from 'react'

import '../../styles/PreviewRibbon/PreviewRibbon.scss'

/**
 * Fixed banner shown only on admin advisor previews so the page is
 * never mistaken for a live match session. Rendered above both the legacy and
 * redesigned match screens.
 */
const PreviewRibbon = () => (
  <div className="preview-ribbon" role="status" data-testid="preview-ribbon">
    Advisor Preview: not a live match session
  </div>
)

export default PreviewRibbon
